"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractIsActiveAt = exports.getContractFuelAsKey = exports.getClockingHours = void 0;
var date_fns_1 = require("date-fns");
function getClockingHours(timePatternRegime) {
    var _a;
    //For some meters, the clock the meter is working on stays on GMT even when clocks change for BST
    //Teleswitch meters have clocking hours controlled by radio signal (and are soon to be turned off/be replaced)
    var clockingHoursMap = new Map([
        [43, { hours: '(07:30-00:30 GMT)', staysOnGmt: true, isTeleswitch: false }],
        [
            210,
            { hours: '(00:30-07:30 GMT)', staysOnGmt: true, isTeleswitch: false },
        ],
        [50, { hours: '(06:30-23:30 GMT)', staysOnGmt: true, isTeleswitch: false }],
        [
            222,
            { hours: '(23:30-06:30 GMT)', staysOnGmt: true, isTeleswitch: false },
        ],
        [40, { hours: '(07:00-00:00 GMT)', staysOnGmt: true, isTeleswitch: false }],
        [
            206,
            { hours: '(00:00-07:00 GMT)', staysOnGmt: true, isTeleswitch: false },
        ],
        [
            278,
            { hours: '(23:30-07:30 GMT)', staysOnGmt: true, isTeleswitch: false },
        ],
        [
            289,
            { hours: '(07:30-23:30 GMT)', staysOnGmt: true, isTeleswitch: false },
        ],
        [
            374,
            {
                hours: '(00:00-05:00, 13:00-16:00, 20:00-22:00 GMT)',
                staysOnGmt: true,
                isTeleswitch: false,
            },
        ],
        [
            375,
            {
                hours: '(05:00-13:00, 16:00-20:00, 22:00-00:00 GMT)',
                staysOnGmt: true,
                isTeleswitch: false,
            },
        ],
        [
            376,
            {
                hours: '(04:30-07:30, 13:30-16:30, 20:30-00:30)',
                staysOnGmt: false,
                isTeleswitch: false,
            },
        ],
        [
            377,
            {
                hours: '(00:30-04:30, 07:30-13:30, 16:30-20:30)',
                staysOnGmt: false,
                isTeleswitch: false,
            },
        ],
        [
            327,
            { hours: '(23:00-07:30 GMT)', staysOnGmt: true, isTeleswitch: false },
        ],
        [
            336,
            { hours: '(07:30-23:00 GMT)', staysOnGmt: true, isTeleswitch: false },
        ],
        [
            395,
            {
                hours: '(04:30-07:30, 13:00-16:00, 20:30-00:30)',
                staysOnGmt: false,
                isTeleswitch: false,
            },
        ],
        [
            396,
            {
                hours: '(00:30-04:30, 07:30-13:00, 16:00-20:30)',
                staysOnGmt: false,
                isTeleswitch: false,
            },
        ],
        [14019, { hours: '', staysOnGmt: true, isTeleswitch: true }],
        [1101, { hours: '(09:00-23:00)', staysOnGmt: false, isTeleswitch: false }],
        [
            1102,
            {
                hours: '(7h between 23:00-09:00)',
                staysOnGmt: false,
                isTeleswitch: false,
            },
        ],
        [1103, { hours: '', staysOnGmt: false, isTeleswitch: true }],
        [
            1059,
            {
                hours: '(09:00-23:00)',
                staysOnGmt: true,
                isTeleswitch: false,
            },
        ],
        [
            1060,
            {
                hours: '(7-7.25h between 23:00-09:00)',
                staysOnGmt: true,
                isTeleswitch: false,
            },
        ],
        [14149, { hours: '', staysOnGmt: true, isTeleswitch: true }],
        [14025, { hours: '', staysOnGmt: true, isTeleswitch: true }],
        [14031, { hours: '', staysOnGmt: true, isTeleswitch: true }],
        [
            1422,
            {
                hours: '(05:00-13:00, 16:00-20:00, 22:00-00:00 GMT)',
                staysOnGmt: true,
                isTeleswitch: false,
            },
        ],
        [
            1423,
            {
                hours: '(00:00-05:00, 13:00-16:00, 20:00-22:00 GMT)',
                staysOnGmt: true,
                isTeleswitch: false,
            },
        ],
        [1088, { hours: '', staysOnGmt: true, isTeleswitch: true }],
        [14044, { hours: '', staysOnGmt: true, isTeleswitch: true }],
    ]);
    if (timePatternRegime) {
        return (_a = clockingHoursMap.get(timePatternRegime)) !== null && _a !== void 0 ? _a : null;
    }
    return null;
}
exports.getClockingHours = getClockingHours;
function getContractFuelAsKey(_a) {
    var fuel = _a.fuel;
    return fuel.toLowerCase() == 'gas' ? 'gas' : 'electricity';
}
exports.getContractFuelAsKey = getContractFuelAsKey;
// TODO: Use timezone from supply point to more accurately obtain an active contract
function contractIsActiveAt(activeDate, _a) {
    var startDate = _a.startDate, endDate = _a.endDate;
    var contractStartDate = new Date(startDate);
    var contractEndDate = endDate && new Date(endDate);
    return (dateComparisonWithEquality(activeDate, contractStartDate, date_fns_1.isAfter) &&
        (!contractEndDate ||
            dateComparisonWithEquality(activeDate, contractEndDate, date_fns_1.isBefore)));
}
exports.contractIsActiveAt = contractIsActiveAt;
function dateComparisonWithEquality(dateLeft, dateRight, comparisonFn) {
    return (0, date_fns_1.isEqual)(dateLeft, dateRight) || comparisonFn(dateLeft, dateRight);
}
